import { render, staticRenderFns } from "./PageBlockLatest.vue?vue&type=template&id=719c781c&"
import script from "./PageBlockLatest.vue?vue&type=script&lang=js&"
export * from "./PageBlockLatest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports